<template>
  <v-dialog
    :value="state.open"
    max-width="440"
    persistent>
    <v-card class="confirm">
      <div class="confirm__title">
        <v-icon
          v-if="state.danger"
          color="error"
          class="mr-2">
          mdi-alert-octagon-outline
        </v-icon>
        {{ state.title }}
      </div>
      <p class="confirm__message">
        {{ state.message }}
      </p>
      <div class="confirm__actions">
        <v-btn
          text
          @click="answer(false)">
          Annuler
        </v-btn>
        <v-btn
          :color="state.danger ? 'error' : 'primary'"
          depressed
          @click="answer(true)">
          {{ state.confirmLabel }}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
  import { confirmState, answerConfirm } from '../plugins/confirm'

  export default {
    name: 'ConfirmDialog',
    computed: {
      state () {
        return confirmState
      }
    },
    methods: {
      answer (value) {
        answerConfirm(value)
      }
    }
  }
</script>

<style scoped>
  .confirm {
    padding: 22px 24px 16px;
  }
  .confirm__title {
    display: flex;
    align-items: center;
    font-size: 17px;
    font-weight: 600;
  }
  .confirm__message {
    margin: 10px 0 18px;
    color: #52525b;
    white-space: pre-line;
  }
  .confirm__actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
</style>
